import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import MyAccountPage from './MyAccountPage.js';

export default WithGASetup(MyAccountPage, AuthContext);
